import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FlexPane"*/ './lazyIndex'),
    {
        name: 'FlexPane',
        initializer: m => m.initializeBundle,
    }
);

// Export actions
export const lazyShowFlexPane: LazyAction<
    typeof lazyIndex.mountAndShowFlexPane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mountAndShowFlexPane);
export const lazyHideFlexPane: LazyAction<typeof lazyIndex.hideFlexPane, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.hideFlexPane);
